export const icons = {
  danger: 'icon-exclamation-triangle',
  info: 'icon-info-circle',
  success: 'icon-check-circle',
  warning: 'icon-exclamation-circle',
  neutral: 'icon-info-circle',
  none: '',
} as const

export type BannerIconType =
  | typeof icons[keyof typeof icons]
  | 'icon-magic'
  | 'icon-edit'
  | 'icon-users'

export const levels = {
  page: 'page',
  system: 'system',
} as const

export type bannerLevelType = typeof levels[keyof typeof levels]

export const variants = {
  danger: 'danger',
  info: 'info',
  success: 'success',
  warning: 'warning',
  neutral: 'neutral',
} as const

export type BannerVariantType = typeof variants[keyof typeof variants]
